// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"9f8ec4d3","551":"96662d09","640":"11df273e"}[chunkId] + ".chunk.js";
};